import { useEffect, useRef } from 'react';

const useOutsideClick = ({
  shouldWatch = true,
  callback,
}: {
  shouldWatch?: boolean;
  callback: () => void;
}) => {
  const ref = useRef<any>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target) && shouldWatch) {
        callback();
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [callback, ref, shouldWatch]);

  return ref;
};

export default useOutsideClick;
